module.exports = __webpack_public_path__ + "static/media/aw-whistledog-2024-dt-en.7fe79916.jpg";